import { forwardRef, type LabelHTMLAttributes } from "react";
import { cn } from "../utils/cn";

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

/**
 * Form field label. A styled native <label>; pair it with a control via
 * `htmlFor` so clicking the label focuses the field and screen readers announce
 * it. Radix has no label primitive worth the dependency here.
 */
export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn(
        "text-sm font-medium leading-none text-foreground",
        "peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className,
      )}
      {...props}
    />
  ),
);
Label.displayName = "Label";
